(function (angular) {
    angular.module('app')
        .directive('currencyformatter', ['$filter', function ($filter) {
            return {
                require: 'ngModel',
                scope: {
                    restriction: '@'
                },
                link: function (scope, element, attrs, ctrl) {
                    ctrl.$formatters.push(function (data) {
                        // convert data to currency format
                        var formatted = $filter('currency')(data);
                        return formatted;
                    });
                }
            }
        }]);
})(angular);